<template>
  <div class="row">
    <div class="title">
      {{ employee.title }}
    </div>
    <div
      v-if="employee.specialty"
      class="specialty"
    >
      {{ employee.specialty }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemEmployee',
  props: {
    employee: { required: true, type: Object },
  },
}
</script>

<style scoped>
.row {
  display: flex;
  gap: 10px;
  padding: 10px 10px;
  width: 100%;
  align-items: center;
  cursor: pointer;
}
.title {
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.specialty {
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
</style>